import { api } from "./api";

/**
 * Economía de tokens: saldo, planes, recarga y propinas.
 *
 * `getBalanceService` acepta un token explícito porque el hook de sesión lo
 * llama justo después de entrar, antes de que la sesión esté guardada en
 * localStorage, que es de donde lo lee el cliente por defecto.
 */

const authFor = (token) => (token ? { Authorization: `Bearer ${token}` } : undefined);

export const getBalanceService = (token) =>
    api.get('/tokens/balance', { headers: authFor(token) });

export const getAccessService = (token) => api.get('/tokens/access', { headers: authFor(token) });

export const getPlansService = (token) => api.get('/tokens/plans', { headers: authFor(token) });

export const getGatewaysService = (token) =>
    api.get('/tokens/gateways', { headers: authFor(token) });

export const rechargeService = (body, token) =>
    api.post('/tokens/recharge', body, { headers: authFor(token) });

export const captureService = (body, token) =>
    api.post('/tokens/capture', body, { headers: authFor(token) });

/** Propina a una modelo; con `room_id` se anuncia en el chat de su sala. */
export const transferService = (body, token) =>
    api.post('/tokens/transfer', body, { headers: authFor(token) });

export const getTransactionsService = (params = {}) =>
    api.get('/tokens/transactions', { params });
